// extracted by css-extract-rspack-plugin
export default {"ChartCardDescriptionText":"Description-module__ChartCardDescriptionText__eQN_NWt"};